/**
 * GraphQL Client
 * Provides GraphQL query/mutation operations
 */

import axios from 'axios';
import authService from '../auth/authService';
import { getTenantConfig } from '../../config/tenantConfig';

/**
 * Execute a GraphQL query or mutation
 * @param {Object} options - GraphQL options
 * @param {string} options.query - GraphQL query string
 * @param {Object} options.variables - Query variables
 * @param {string} options.authMode - Auth mode: 'API_KEY' or 'AMAZON_COGNITO_USER_POOLS'
 * @returns {Promise<Object>} GraphQL response
 */
export const graphql = async (options) => {
  const config = getTenantConfig();
  const url = config.graphql.endpoint;

  const headers = {
    'Content-Type': 'application/json'
    // NOTE: X-Tenant-ID header removed - same reasoning as httpClient
    // GraphQL backend should extract tenant context from JWT token
  };

  // Handle authentication mode
  if (options.authMode === 'API_KEY') {
    headers['x-api-key'] = config.graphql.apiKey;
  } else {
    // Use ID token for authenticated requests (default)
    try {
      const user = await authService.currentAuthenticatedUser();
      headers.Authorization = `Bearer ${user.signInUserSession.idToken.jwtToken}`;
    } catch (error) {
      console.warn('No authenticated user for GraphQL request');
    }
  }

  try {
    const response = await axios.post(
      url,
      {
        query: options.query,
        variables: options.variables
      },
      { headers }
    );

    // Check for GraphQL errors
    if (response.data.errors) {
      const error = new Error('GraphQL Error');
      error.errors = response.data.errors;
      throw error;
    }

    return response;
  } catch (error) {
    console.error('GraphQL request failed:', error);
    throw error;
  }
};
